export const zhCN = {
  travelChat: {
    header: {
      title: '{groupName} 聊天',
      subtitle: '实时群聊',
    },
    time: {
      today: '今天',
      yesterday: '昨天',
    },
    user: {
      unknown: '未知用户',
    },
    loading: {
      text: '加载消息中...',
    },
    empty: {
      title: '暂无消息',
      subtitle: '发送第一条消息开始聊天',
    },
    input: {
      placeholder: '输入消息...',
    },
    errors: {
      sendFailed: '发送失败',
      networkError: '网络错误，请稍后重试',
      connectionFailed: '连接失败',
      realtimeDisconnected: '实时连接已断开',
    },
    status: {
      connecting: '正在连接...',
      connected: '已连接',
      disconnected: '未连接',
    },
  },
};

export const en = {
  travelChat: {
    header: {
      title: '{groupName} Chat',
      subtitle: 'Real-time group chat',
    },
    time: {
      today: 'Today',
      yesterday: 'Yesterday',
    },
    user: {
      unknown: 'Unknown User',
    },
    loading: {
      text: 'Loading messages...',
    },
    empty: {
      title: 'No messages',
      subtitle: 'Send the first message to start chatting',
    },
    input: {
      placeholder: 'Type a message...',
    },
    errors: {
      sendFailed: 'Failed to send',
      networkError: 'Network error, please try again',
      connectionFailed: 'Connection failed',
      realtimeDisconnected: 'Realtime connection disconnected',
    },
    status: {
      connecting: 'Connecting...',
      connected: 'Connected',
      disconnected: 'Disconnected',
    },
  },
};
